import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "reload",
  "use": "reload-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"reload\"><title>reload</title><path d=\"M17,5l.3.42H15.13a.7.7,0,0,0,0,1.39H19.3a.7.7,0,0,0,.7-.7V2.3a.7.7,0,1,0-1.39,0V4.86l-.48-.67A10,10,0,1,0,20,10a.7.7,0,1,0-1.39,0A8.62,8.62,0,1,1,17,5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/reload.svg
// module id = hGTH
// module chunks = 264